import {siteSettings} from "../../utils/siteSettings";

import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';

	// const name = document.getElementById('payer_name');
	const firstName = document.getElementById('payer_first_name');
	const lastName = document.getElementById('payer_last_name');
	const email = document.getElementById('payer_email');
	const phonenumber = document.getElementById('payer_phonenumber');
	// const cardNumber = document.getElementById('card-number');
	// const cardTerm = document.getElementById('card-term');
	// const cvv = document.getElementById('cvv');
	// const holder = document.getElementById('holder');
	const country = document.getElementById('country');
	const confirmButton = document.getElementById('confirm-button');
	const necessaryInputsArr = [firstName, lastName, email, phonenumber, /*cardNumber, cardTerm, cvv, holder,*/ country];

	/**
	 * Checking if all inputs were filled.
	 */
	const inputsFillValidation = () => {
		let filledInputs = 0;
		necessaryInputsArr.map(item => {
			item.value !== '' && filledInputs++;
		});
	};

	necessaryInputsArr.map(item => {
		item.addEventListener('change', inputsFillValidation);
		item.addEventListener('keyup', inputsFillValidation);
	});

	const area_code = document.querySelector("#payer_phonenumber");
	intlTelInput(area_code, {
		utilsScript:
			"https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
		initialCountry: 'no',
		separateDialCode: true
	});
	inputsFillValidation();

